<template>
  <div id="footer">
    <!--服务咨询-->
    <!-- <div class="service-consultation">
            <p class="service-consultation-title">整合行业解决方案，助力业务升级</p>
            <a href="" class="service-consultation-a">服务咨询</a>
        </div> -->
    <!-- 尾部 -->
    <div class="bfooter">
      <div class="bfooter-content">
        <div class="bfooter-list">
          <div class="bfooter-list-d">
            <!-- <img src="https://img.deepbaytech.com/images/logo@2x.png" alt="" style="width:160px;height:auto"> -->
            <img
              src="../../../public/images/深湾科技logo2021-横版@2x.png"
              alt=""
              style="width:160px;height:auto"
            />
          </div>
          <div class="bfooter-list-d">
            <p>
              联系我们：13051739989
            </p>
            <p>
              人才招聘：xinweini@deepbaytech.com
            </p>
          </div>
          <div class="bfooter-list-d">
            <p>公司地址：北京市朝阳区三里屯街道耀莱国际广场A座4层</p>
          </div>
        </div>
        <p class="bfooter-text">
          <a href="https://beian.miit.gov.cn/" target="_blank">
            Copyright ©2020 北京深湾科技有限公司 版权所有 京ICP备16026234号-1
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
};
</script>
<style scoped>
/* #footer{
    position: absolute;
    bottom: 0;
    left: 0;
} */
.bfooter {
  width: 100%;
  height: 200px;
  background: #010017;
  color: #ececef;
  font-size: 16px;
}
.bfooter-content {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
}
.bfooter-list {
  display: flex;
  justify-content: space-between;
  padding: 44px 0;
  border-bottom: 1px solid #333;
}
.bfooter-text {
  padding-top: 20px;
  text-align: center;
  font-size: 12px;
}
a {
  text-decoration: none;
  color: #fff;
}
</style>
